import * as ROUTES from './routes.js';

export const ACTIVITY_INTERVAL = 10 * 1000;
// Add activity interval so we can have the timer start at nicer numbers (1 minute or so)
// Because the timer is reset after the first {ACTIVITY_INTERVAL} seconds
export const INACTIVITY_THRESHOLD = 120 * 1000 + ACTIVITY_INTERVAL;
export const ATTENTION_TIME_FIELDS = {
    BATCH_AWAITING: 'batch_awaiting_time',
    [ROUTES.QUEUE]: 'queue_time',
    [ROUTES.SEARCH]: 'search_time',
    [ROUTES.QUICK_SEARCH]: 'quick_search_time',
    [ROUTES.WORKSPACES]: 'workspace_list_time',
    [ROUTES.NEW_WORKSPACE]: 'new_workspace_time',
    [ROUTES.WORKSPACE]: 'workspace_home_time',
    [ROUTES.CREATE_QUEUE]: 'create_queue_time',
    [ROUTES.NEW_QUEUE]: 'new_queue_time',
    [ROUTES.NEW_SEARCH]: 'new_search_time',
};
export const ATTENTION_TIME_API_ACTION_MAP = {
    [ATTENTION_TIME_FIELDS.BATCH_AWAITING]: 'empty_queue',
    [ATTENTION_TIME_FIELDS[ROUTES.QUEUE]]: 'active_on_batch',
    [ATTENTION_TIME_FIELDS[ROUTES.SEARCH]]: 'active_on_search',
    [ATTENTION_TIME_FIELDS[ROUTES.QUICK_SEARCH]]: 'active_on_quick_search',
    [ATTENTION_TIME_FIELDS[ROUTES.WORKSPACES]]: 'active_on_workspaces',
    [ATTENTION_TIME_FIELDS[ROUTES.NEW_WORKSPACE]]: 'active_on_new_workspace',
    [ATTENTION_TIME_FIELDS[ROUTES.WORKSPACE]]: 'active_on_workspace_home',
    [ATTENTION_TIME_FIELDS[ROUTES.CREATE_QUEUE]]: 'active_on_create_queue',
    [ATTENTION_TIME_FIELDS[ROUTES.NEW_QUEUE]]: 'active_on_new_queue',
    [ATTENTION_TIME_FIELDS[ROUTES.NEW_SEARCH]]: 'active_on_new_search',
};
export const TIME_EVENTS = {
    ROUTE_CHANGE: 'route_change',
    PAGE_HIDE: 'page_hide',
    PAGE_CLOSE: 'page_close',
};

export const TIME_TRACKING_EVENTS = {
    start: () => 'start tracking',
    user_activity: () => 'user activity',
    idle: () => 'user became idle',
    reactivate: () => 'user no longer idle',
    content_action: (content_id, action) => `content ${content_id} ${action}`,
    route_change: (from, to) => `changing routes from ${from} to ${to}`,
};
